<template>
  <div class="w-100 my-5">
    <div class="row mx-auto">
      <div class="col-sm m-2 box-white row vertical-center">
        <div class="col-sm my-1 vertical-center" v-if="eventInfo">
          <img :width="60" :height="40" :src="eventInfo.thumbnailUrl || eventInfo.photoUrl" />
          <span class="ml-2 font-15 font-bold">{{ eventInfo.name }}</span>
        </div>
        <div class="col-sm my-1 vertical-center" v-if="eventInfo">
          <span class="font-bold font-15 alpha-07">{{ $t('remain_balance') }}:</span>
          <span class="mx-5 font-bold font-20 color-blue">{{ getPriceFormat(eventInfo.wristbandBalance || 0) }}</span>
        </div>
        <div class="col-sm my-1 vertical-center" v-if="eventInfo">
          <span class="font-bold font-15 alpha-07">{{ $t('handling_fee') }}:</span>
          <span class="mx-5 font-bold font-20 color-blue">{{ getPriceFormat((eventInfo.wristbandBalance || 0) * WRISTBAND_HANDLING_FEE_PERCENT) }}</span>
        </div>
        <div :class="`col-sm my-1 vertical-center ${isMobile ? '' : 'justify-content-end'}`">
          <input class="w-75" v-model="keyword" />
          <v-btn class="ml-2" icon small @click="keyword = ''" :disabled="!keyword">
            <i :class="`flaticon-circle ${keyword.length > 0 ? 'color-blue' : ''}`"></i>
          </v-btn>
        </div>
      </div>
    </div>
    <div class="row my-5" v-if="(items.length > 0)">
      <div :class="`col-sm${colSmSize}`" v-for="(item, index) in items" :key="(item, index)">
        <v-card class="my-2 box-white d-flex flex-column">
          <div class="my-1 d-flex justify-content-between vertical-center">
            <div class="vertical-center pointer" @click="openUserPage(item.userId)">
              <img class="circle-image-30" :src="item.userPhotoUrl" />
              <span class="ml-2 ellipsis font-15 font-bold" :title="item.userName">{{ item.userName }}</span>
              <img class="ml-2" :src="assets.openNewTab" width="15" />
            </div>
            <span class="font-15 font-bold color-blue">{{ item.qrCodeNumber }}</span>
          </div>
          <VueQrcode
            class="mx-auto"
            :value="item.qrCode"
            :options="qrOptions"
            level="H"
          />
          <div class="my-1 d-flex justify-content-between vertical-center" v-if="item.balance">
            <span class="font-12">{{ $t('remain_balance') }}</span>
            <span class="font-15 font-bold color-blue">{{ getPriceFormat(item.balance) }}</span>
          </div>
          <div class="my-1 d-flex justify-content-between vertical-center" v-if="item.payoutAmount">
            <span class="font-12">{{ $t('payout_amount') }}</span>
            <span class="font-15 font-bold color-red">{{ getPriceFormat(item.payoutAmount) }}</span>
          </div>
          <div class="my-1 d-flex justify-content-between vertical-center" v-if="item.blockedAt">
            <div class="vertical-center">
              <i class="fa fa-calendar-alt font-12 color-red"></i>
              <span class="ml-2 font-12 color-red">{{ getDateStringFromTimestamp(item.blockedAt) }}</span>
              &nbsp;
              <i class="font-12 color-red">[Blocked]</i>
            </div>
            <v-btn class="button-normal" @click="unblockWristbandInfoTask(item.wristbandId)">
              <span>Unblock</span>
            </v-btn>
          </div>
          <div class="my-1 d-flex justify-content-between vertical-center" v-else>
            <div class="vertical-center ">
              <i class="fa fa-calendar-alt font-12 color-blue"></i>
              <span class="ml-2 font-12">{{ getDateStringFromTimestamp(item.updatedAt || item.createdAt) }}</span>
            </div>
            <v-btn class="button-red" @click="blockWristbandInfoTask(item.wristbandId)">
              <span>Block</span>
            </v-btn>
          </div>
        </v-card>
      </div>
    </div>
    <div class="py-40 center" v-else>
      <span class="font-20 alpha-07">{{ $t('no_data_found') }}</span>
    </div>
  </div>
</template>


<script>
import VueQrcode from "@chenfengyuan/vue-qrcode";

import { httpsCallable } from 'firebase/functions';
import { functions, firestore } from '../../../main';
import { collection, query, where, getDocs, onSnapshot } from 'firebase/firestore';
import { getPriceFormat, getDecimalFormat, getDateStringFromTimestamp, showLoading } from '../../../functions';

import profile from '@/assets/image/profile.jpg';
import openNewTab from '@/assets/image/open_new_tab.png';

export default {
  name: 'WristbandList',
  components: {
    VueQrcode
  },
  computed: {
    isMobile() {
      return this.$store.state.isMobile;
    },
    colSmSize() {
      return this.$store.state.colSmSize;
    },
    eventList() {
      return this.$store.state.eventList || [];
    },
    eventInfo() {
      if (this.$route.params.eventId) {
        return this.eventList.find(element => element.eventId === this.$route.params.eventId);
      } else {
        return null;
      }
    },
    params() {
      return this.$route.params;
    }
  },
  watch: {
    params() {
      this.keyword = '';
      this.wristbandList = [];
      this.getWristbandListTask1();
      this.getWristbandListTask2();
    },
    keyword() {
      this.refreshData();
    }
  },
  data() {
    return {
      assets: {
        profile,
        openNewTab
      },
      qrOptions: {
        width: 280,
        color: {
          dark: "#170223",
          light: "#FFFFFF",
        },
      },
      cacheUserList: [],
      wristbandList: [],
      items: [],
      keyword: '',
      snapWristbandList1: null,
      snapWristbandList2: null
    }
  },
  mounted() {
    this.cacheUserList = this.$store.state.userList;
    this.wristbandList = [];
    this.getWristbandListTask1();
    this.getWristbandListTask2();
  },
  destroyed() {
    if (this.snapWristbandList1) {
      this.snapWristbandList1();
    }
    if (this.snapWristbandList2) {
      this.snapWristbandList2();
    }
  },
  methods: {
    getPriceFormat,
    getDecimalFormat,
    getDateStringFromTimestamp,
    refreshData() {
      const items = [];
      const keyword = this.keyword.toLowerCase();
      this.wristbandList.forEach(wristbandInfo => {
        var qrCodeNumber = '';
        if (wristbandInfo.qrCode.startsWith(this.PREFIX_EVENTBOX_WRISTBAND)) {
          qrCodeNumber = wristbandInfo.qrCode.split('-').pop();
        } else if (wristbandInfo.qrCode.startsWith(this.PREFIX_EVENTBOX_USER)) {
          qrCodeNumber = 'Virtual Wristband';
        }
        const userInfo = this.cacheUserList.find(element => element.userId === wristbandInfo.userId);
        if (qrCodeNumber && userInfo && userInfo.userName.toLowerCase().includes(keyword)) {
          const item = JSON.parse(JSON.stringify(wristbandInfo));
          item['userName'] = userInfo.userName;
          item['userPhotoUrl'] = userInfo.thumbnailUrl || userInfo.photoUrl || this.assets.profile;
          item['qrCodeNumber'] = qrCodeNumber;
          items.push(item);
        }
      });
      items.sort((a, b) => (a.balance < b.balance) ? 1 : -1);
      this.items = items;
    },
    openUserPage(userId) {
      window.open(`${window.location.origin}/users/0/${userId}`, '_blank');
    },
    getWristbandListTask1() {
      const q = query(collection(firestore, 'wristband'), where('eventId', '==', this.$route.params.eventId), where('balance', '>', 0));
      const loader = showLoading(this, 1);
      this.snapWristbandList1 = onSnapshot(q, querySnapshot => {
        loader.hide();
        const list = [];
        var userIDs = [];
        querySnapshot.forEach(doc => {
          const data = doc.data();
          list.push(data);
          if (data.userId && !this.cacheUserList.find(element => element.userId === data.userId)) {
            userIDs.push(data.userId);
            if (userIDs.length >= 30) {
              this.getUserListTask(userIDs);
              userIDs = [];
            }
          }
        });
        this.wristbandList = this.wristbandList.concat(list);
        this.refreshData();
        if (userIDs.length > 0) {
          this.getUserListTask(userIDs);
        }
      });
    },
    getWristbandListTask2() {
      const q = query(collection(firestore, 'wristband'), where('eventId', '==', this.$route.params.eventId), where('payoutAmount', '>', 0));
      this.snapWristbandList2 = onSnapshot(q, querySnapshot => {
        const list = [];
        var userIDs = [];
        querySnapshot.forEach(doc => {
          const data = doc.data();
          list.push(data);
          if (data.userId && !this.cacheUserList.find(element => element.userId === data.userId)) {
            userIDs.push(data.userId);
            if (userIDs.length >= 30) {
              this.getUserListTask(userIDs);
              userIDs = [];
            }
          }
        });
        this.wristbandList = this.wristbandList.concat(list);
        this.refreshData();
        if (userIDs.length > 0) {
          this.getUserListTask(userIDs);
        }
      });
    },
    getUserListTask(userIDs) {
      const q = query(collection(firestore, 'user'), where('userId', 'in', userIDs));
      getDocs(q).then(querySnapshot => {
        const list = [];
        querySnapshot.forEach(doc => {
          const data = doc.data();
          const deviceType = data.deviceType || '';
          if (window.location.hostname === 'localhost') {
            data['deviceType'] = deviceType;
            if (deviceType.startsWith('Android : ')) {
              data['deviceTypeColor'] = 'color-red';
            } else if (deviceType.startsWith('iOS : ')) {
              data['deviceTypeColor'] = 'color-blue';
            } else if (deviceType.startsWith('Web : ')) {
              data['deviceTypeColor'] = 'color-purple';
            }
          } else {
            const myArray = deviceType.split(' : ');
            if (myArray && myArray.length > 0) {
              data['deviceType'] = myArray[0];
            } else {
              data['deviceType'] = '';
            }
            data['deviceTypeColor'] = 'color-primary';
          }
          if (data.userId === this.$route.params.userId) {
            this.userInfo = data;
          }
          list.push(data);
        });
        this.cacheUserList = this.cacheUserList.concat(list);
        this.$store.commit('set', ['userList', this.cacheUserList]);
        this.refreshData();
      });
    },
    blockWristbandInfoTask(wristbandId) {
      if (!confirm('Are you sure you want to block this Wristband?')) {
        return;
      }
      const params = {
        functionName: 'blockWristband',
        wristbandId: wristbandId,
      };
      const loader = showLoading(this, 1);
      const func = httpsCallable(functions, this.ADMIN_FUNCTION);
      func(JSON.stringify(params)).then(response => {
        loader.hide();
        if (response.data === this.RESULT_SUCCESS) {
          this.$toast.success(this.$t('success'));
        } else {
          this.$toast.error(response.data);
        }
      }).catch(error => {
        loader.hide();
        this.$toast.error(error.code + ', ' + error.message);
      });
    },
    unblockWristbandInfoTask(wristbandId) {
      if (!confirm('Are you sure you want to unblock this Wristband?')) {
        return;
      }
      const params = {
        functionName: 'unblockWristband',
        wristbandId: wristbandId,
      };
      const loader = showLoading(this, 1);
      const func = httpsCallable(functions, this.ADMIN_FUNCTION);
      func(JSON.stringify(params)).then(response => {
        loader.hide();
        if (response.data === this.RESULT_SUCCESS) {
          this.$toast.success(this.$t('success'));
        } else {
          this.$toast.error(response.data);
        }
      }).catch(error => {
        loader.hide();
        this.$toast.error(error.code + ', ' + error.message);
      });
    }
  }
};
</script>